import Button from '../Button.jsx';

const PanelActionButton = ({ children, icon, onClick, className = '', size = 'xl', disabled = false, loading = false, ...props }) => {
  return (
    <Button className={`panel-action-button full-width ${className}`} size={size} icon={icon} onClick={onClick} disabled={disabled} loading={loading} {...props}>
      {children}
    </Button>
  );
};

export default PanelActionButton;
